export const noDataText = "No companies in this bucket";
